import HelmetComp from '../../../../../components/helmet/Helmet';
import SuccessAction from '../../../../../components/successAction';
import { SuccessActionPropsType } from '../../../../../types/commonTypes';
import { title } from '../../../../../utils/matchingTitle';

const ChangePasswordSuccess = () => {
  const props: SuccessActionPropsType = {
    title: 'パスワードが更新されました。',
    textDescription: (
      <>
        ご登録いただいたメールアドレス宛に
        <br />
        更新完了メールをお送りいたします。
      </>
    ),
    castRegister: true,
    isLogin: true,
  };
  return (
    <div>
      <HelmetComp title={title.castChangePasswordSuccess} cast />
      <SuccessAction {...props} />
    </div>
  );
};

export default ChangePasswordSuccess;
